export default function SelectDepartmentTeamMembersDialogController(
  $timeout,
  $scope,
  $filter,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSaveSelections = handleSaveSelections;
  vm.handleSelectUser = handleSelectUser;
  vm.handleSelectOwner = handleSelectOwner;

  _resetViewModel();

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSaveSelections() {
    vm.department.departmentTeamMembers = $filter('filter')(
      vm.department.users, {
        isBCPDepartmentTeamMember: true,
      }
    );
    _closeDialog();
  }

  function handleSelectUser(user) {
    // Note: The user flag is not set yet, it's only been signaled to change
    if (user.isBCPDepartmentTeamMember) {
      user.isBCPDepartmentOwner = false;
    }
  }

  function handleSelectOwner(user) {
    // Note: The ownership flag is not set yet, it's only been signaled to change
    if (!user.isBCPDepartmentOwner) {
      user.isBCPDepartmentTeamMember = true;
    }
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.selectDepartmentTeamMembersDialog);
  }

  function _resetViewModel() {
    vm.department.newName = vm.department.name;
    vm.department.departmentTeamMembers = $filter('filter')(
      vm.department.users, {
        isBCPDepartmentTeamMember: true,
      }
    );
  }
}

SelectDepartmentTeamMembersDialogController.$inject = [
  '$timeout',
  '$scope',
  '$filter',
  'ssDialogService',
  'editDepartmentDialog'
];
